export default function HCPReports() {
  return (
    <div>
      <h1>Relatórios HCP</h1>
      <p>Visualização de relatórios do HCP.</p>
    </div>
  );
}
